import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Models
import mRollout from 'models/rollout';
// Custom
import { getRolloutsList, deleteRollout, refreshList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import { addPath, navigateToShow } from 'rollouts/navigation';
import { AddTextButton } from 'components/buttons/TextButtons';
import MainListTemplate from 'components/templates/MainListTemplate';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withLoading from 'hocs/WithLoading';
import withTitle from 'hocs/WithTitle';
import RolloutFilters from 'rollouts/assets/main/RolloutFilters';
import RolloutRow from 'rollouts/assets/main/RolloutRow';

class RolloutsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteRollout = this.handleDeleteRollout.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { deleted, handleRefreshList } = this.props;
    if (!prevProps.deleted && deleted) {
      handleRefreshList();
    }
  }

  // Handlers
  handleDeleteRollout(rollout) {
    const { handleDisplayConfirm, handleDeleteRollout } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteRollout', values: { rolloutDesc: mRollout.desc(rollout) } },
      () => handleDeleteRollout(rollout.id),
    );
  }

  handleRowDbleClick(rollout) {
    const { handleStartLoading } = this.props;
    if (rollout) {
      // Display loader and display rollout
      handleStartLoading();
      _delay(() => navigateToShow(rollout.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <RolloutRow
        {...props}
        onDelete={this.handleDeleteRollout}
      />
    );
  }

  render() {
    const { rollouts, handleGetRolloutsList } = this.props;

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.rolloutsList" />
        }
        icon={mRollout.icon}
        displayRefresh
        actionButtons={[
          <AddTextButton key="add" primary path={addPath()} />,
        ]}
        name={mRollout.name}
        listFeatures={mRollout.listFeatures}
        withActions
        elementsData={{
          loading: rollouts.loading,
          elements: rollouts.elements,
          handleGetList: handleGetRolloutsList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={
          <RolloutFilters />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

RolloutsList.propTypes = {
  rollouts: fullListShape.isRequired,
  deleted: PropTypes.bool.isRequired,
  handleRefreshList: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetRolloutsList: PropTypes.func.isRequired,
  handleDeleteRollout: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  rollouts: state.rollout.list,
  deleted: state.rollout.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleGetRolloutsList: (pagination, sort, filters) => {
    dispatch(getRolloutsList(pagination, sort, filters));
  },
  handleDeleteRollout: (id) => {
    dispatch(deleteRollout(id));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmDialog,
  withLoading,
  withTitle('pageTitle.rollouts'),
)(RolloutsList);



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/routes/list/components/RolloutsList.js